import Common from '../../Common';

interface Body {
	type: string
	host: string
	login: string
	password: string
	id?: string | number
	domain?: string
	credentials?: string
}

export interface CompanyIntegration {
	id: id
	pbx_company_id: id
	type: string
	host: string
	login: string
	password: string
	domain: string
	credentials: string | null
	proxy_host: string | null
	proxy_port: string
	proxy_login: string | null
	proxy_password: string | null
	access_token: string | null
	tenant: string | null
	token_expiry: string
	failed_renew: string
	used_for: string
}

const Integration = class extends Common {
	browse = (companyId: id): CustomResponse<{
		count: number
		integrations: CompanyIntegration[]
	}> =>
		this.get(`/company/${companyId}/integrations`)

	create = (companyId: id, body: Body) =>
		this.post(`/company/${companyId}/integrations`, body)

	delete = (companyId: id, integrationId: id) =>
		this.doDelete(`/company/${companyId}/integrations/${integrationId}`)

	status = (companyId: id) =>
		this.get(`/company/${companyId}/integrations/status`)

	resync = (companyId: id, integrationId: id, id: id) =>
		this.post(`/company/${companyId}/integrations/${integrationId}/resync/${id}`)

	refresh = (companyId: id, integrationId: id, userId: id) =>
		this.post(`/company/${companyId}/integrations/${integrationId}/refresh/${userId}`)

	log = (companyId: id, integrationId: id, userId: id, subject: string) =>
		this.post(`/company/${companyId}/integrations/log/${integrationId}/${userId}/${subject}`)
}

export default Integration
